
import { defineComponent, ref } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "App",
  setup() {
    let isLoading = ref(false);
    const route = useRoute();

    const { t } = useI18n(); // call `useI18n`, and spread `t` from  `useI18n` returning
    return {
      isLoading,
      route,
      t,
    };
  },
});
